import React, { useState, useEffect } from "react";
import { ErrorMessage } from "@bca/ui-library";

interface CountdownTimerProps {
  saleEndDate: string;
}

const CountdownTimer: React.FunctionComponent<CountdownTimerProps> = ({
  saleEndDate,
}) => {
  const [minutes, setMinutes] = useState(getRemainingMinutes(saleEndDate));
  const [seconds, setSeconds] = useState(getRemainingSeconds(saleEndDate));
  const saleEnd = new Date(saleEndDate);
  const saleEndHour = getEndHour(saleEnd);
  const saleEndMinutes = getEndMinutes(saleEnd);

  useEffect(() => {
    const interval = setInterval(() => {
      const remainingMinutes = getRemainingMinutes(saleEndDate);
      const remainingSeconds = getRemainingSeconds(saleEndDate);
      if (remainingMinutes <= 0 && remainingSeconds <= 0) {
        setMinutes(0);
        setSeconds(0);
        clearInterval(interval);
        return;
      }
      setMinutes(remainingMinutes);
      setSeconds(remainingSeconds);
    }, 1000);
    return () => clearInterval(interval);
  }, [saleEndDate]);

  return (
    <ErrorMessage
      errorMessage={`Ends in ${minutes}m ${seconds}s (Today at ${saleEndHour}:${saleEndMinutes})`}
    ></ErrorMessage>
  );
};

const getRemainingMinutes = (saleEndDate) => {
  const expirationTime = new Date(saleEndDate).getTime();
  const now = new Date().getTime();
  const timeDifference = expirationTime - now;
  return Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
};

const getRemainingSeconds = (saleEndDate) => {
  const expirationTime = new Date(saleEndDate).getTime();
  const now = new Date().getTime();
  const timeDifference = expirationTime - now;
  return Math.floor((timeDifference % (1000 * 60)) / 1000);
};

const getEndHour = (saleEnd) => {
  return saleEnd.getHours() < 10
    ? `0${saleEnd.getHours()}`
    : saleEnd.getHours();
};

const getEndMinutes = (saleEnd) => {
  return saleEnd.getMinutes() < 10
    ? `0${saleEnd.getMinutes()}`
    : saleEnd.getMinutes();
};

export default CountdownTimer;
